const env = {
  gtmId: process.env.REACT_APP_GTM_ID || '',
};

export default env;
